__turbopack_context__.v({
  "Label": "HAfmHa_Label",
  "Switch": "HAfmHa_Switch",
  "Thumb": "HAfmHa_Thumb",
  "body": "HAfmHa_body",
  "root": "HAfmHa_root",
});
